import { render } from "./CZScannedInvoices.vue?vue&type=template&id=56f5412a&scoped=true&ts=true"
import script from "./CZScannedInvoices.vue?vue&type=script&lang=ts"
export * from "./CZScannedInvoices.vue?vue&type=script&lang=ts"

import "./CZScannedInvoices.vue?vue&type=style&index=0&id=56f5412a&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f5412a"]])

export default __exports__